import React from 'react';
import PreviewContent from '../../components/general/PreviewContent';
import { IconBubble } from 'ui';

const ThumbnailOrBubbleIcon = ({ thumbnail, type }) => {
  function renderPreview(contentUrl, type) {
    return <PreviewContent previewImage={true} contentUrl={contentUrl} type={type} canOpenImageDialog={false} />;
  }

  return (
    <>
      {thumbnail && renderPreview(thumbnail, 'CTTY_07')}
      {!thumbnail && (
        <div className="thumbnail-or-bubble-icon__controls-player-icon">
          <IconBubble name={type} size="3xl" />
        </div>
      )}
    </>
  );
};

export default ThumbnailOrBubbleIcon;
